import {getYear} from '../utilities/get-year.js';
import linkedinIcon from '../website-images/contact-page/linkedin-logo.jpg';
import githubIcon from '../website-images/contact-page/github-logo.jpg';

function Footer() {
    return (
        <footer className="site-footer">
            <p>&copy; Patrick Neil {getYear()}</p>
            <div className="footer-images">
            <a className="footer-icon hover-underline-animation" href="https://www.linkedin.com/in/patrick-neil-5692a0133/"><img  src={linkedinIcon} alt="Linked in Icon" /></a>
            <a className="footer-icon hover-underline-animation" href="https://github.com/PLN-projects"><img  src={githubIcon} alt="github icon" /></a>
            </div>
        </footer>
    )
}

export default Footer
